

const validateDocumentVerificationData = (formData) => {
  const errors = {};

  const FILE_SIZE_LIMIT = 3 * 1024 * 1024;
  const COMPILED_FILE_SIZE_LIMIT = 15 * 1024 * 1024;

  // Validate files
  const validateFile = (file, fieldName) => {
     if (file && file.size > FILE_SIZE_LIMIT) {
          errors[fieldName] = `${fieldName.replace(/([A-Z])/g, ' $1')} size must be less than 3 MB`;
      }
  };

 
  
   // Validate files
   const validateCompliedDocuments = (file, fieldName) => {
    if (!file) {
      errors[fieldName] = `${fieldName.replace(/([A-Z])/g, ' $1')} is required`;
    } else {
      if (file.size > COMPILED_FILE_SIZE_LIMIT) {
        errors[fieldName] = `documents size must be less than 15 MB`;
      }
      if (file.type !== 'application/pdf') {
        errors[fieldName] = `${fieldName.replace(/([A-Z])/g, ' $1')} must be a PDF`;
      }
    }
  };

  // Required fields check
  if (!formData.name) errors.name = 'Name is required';
  if (!formData.relationshipType) errors.relationshipType = 'Relationship Type is required';
  if (!formData.relativeName) errors.relativeName = 'Relative Name is required';
  if (!formData.barAssociationId) errors.barAssociationId = 'Bar Association ID is required';
  if (!formData.concernedBarRegistrationDate) errors.concernedBarRegistrationDate = 'Concerned Bar Registration Date is required';
  if (!formData.dateOfBirth) errors.dateOfBirth = 'Date of Birth is required';
  if (!formData.advocateBarId) errors.advocateBarId = 'Advocate Bar ID is required';
  if (!formData.mobileNo) errors.mobileNo = 'Mobile Number is required';
  // if (!formData.aadharCertificate) errors.aadharCertificate = 'Aadhar Certificate is required';
  
  // Email validation
  if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Invalid email format';
  if (!formData.email) errors.email = 'Email is required';
  
  // Validate file sizes
  validateCompliedDocuments(formData.aadharCertificate, 'aadharCertificate');


  validateFile(formData.advocacyDocuments, 'advocacyDocuments');
  validateFile(formData.enrollmentNo, 'enrollmentNo');
  validateFile(formData.enrollmentCertificate, 'enrollmentCertificate');
 
  validateFile(formData.aibePassCertificate, 'aibePassCertificate');
  validateFile(formData.copCertificate, 'copCertificate');
  validateFile(formData.profileImage, 'profileImage');
  validateFile(formData.photo, 'photo');
  
  // Check for required fields with empty string
  if (formData.isAnotherBarMember === undefined) errors.isAnotherBarMember = 'Is Another Bar Member is required';
  if (formData.isAnotherBarMember && (!formData.barAssociationMembershipDetails || formData.barAssociationMembershipDetails === "")) {
    errors.barAssociationMembershipDetails = 'Bar Association Membership Details are required';
  }
  
  // Optional fields check
//   if (!formData.signature) errors.signature = 'Signature is required';
//   if (!formData.status) errors.status = 'Status is required';
  if (!formData.userId) errors.userId = 'User ID is required';

//   // Handling possible null values
//   if (formData.copValitidy === null) errors.copValitidy = 'COP Validity is required';
//   if (formData.joiningDate === null) errors.joiningDate = 'Joining Date is required';

  return errors;
};

export default validateDocumentVerificationData;
